/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NpiLookupService {

    /**
     * NPI Registry Lookup
     * Fetch NPI data from the NPPES registry with optional provider check
     * @returns any No response body
     * @throws ApiError
     */
    public static npiLookup({
        npi,
        checkDup = false,
        runCheck = false,
    }: {
        npi: string,
        /**
         * Check whether a provider already has this NPI in our database (independent of the registry lookup)
         */
        checkDup?: boolean,
        /**
         * Whether to include provider data from internal database
         */
        runCheck?: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/providers/npi/{npi}/',
            path: {
                'npi': npi,
            },
            query: {
                'check_dup': checkDup,
                'run_check': runCheck,
            },
        });
    }

}
